module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1. St. Louis, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SS "), _c('i', [_vm._v("Admiral")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Union Station")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Caves of St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chase Park Plaza Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soulard Market")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laclede’s Landing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemp Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hitchhike Annie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Feasting Fox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forest Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Courthouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zombie Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shaw’s Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Webster Groves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jefferson Barracks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2. Eureka and Pacific, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six Flags Over Mid America")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pacific")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Diamonds–Tri County Truck Stop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3. Defiance and Union, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel Boone Village")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Union")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4. Morse Mill, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5. Stanton, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meramec Caverns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6. Sullivan, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harney Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7. Rolla, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goatman’s Grave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devil’s Elbow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fort Leonard Wood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8. Springfield, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gillioz Theater")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Landers Theater")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walnut Street Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pythian Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maple Park Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MSU")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Springfield National Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilson’s Creek National Battlefield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9. Buffalo, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#ch9.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rack It Pool Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10. Carthage, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ch10.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grand Avenue Bed and Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ch10.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kendrick House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11. Joplin, Missouri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freeman Hospital")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peace Church Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prosperity School Bed and Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joplin Spook Light")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4c9821c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 72
// module chunks = 0